import { Controller } from "@hotwired/stimulus";
import { Collapse } from "bootstrap";

export default class extends Controller {
  static targets = ["content", "collapse"];

  connect() {
    console.log("toggle connected");
  }

  toggle_check_show(event) {
    this.contentTarget.classList.toggle("d-none", !event.target.checked);
  }

  toggle(event) {
    event.preventDefault();
    const collapse = Collapse.getOrCreateInstance(this.collapseTarget);
    collapse.toggle();
  }

  // JM: onderstaande kan vast generieker, maar nu even niet

  toggle_factuur_email(event) {
    event.preventDefault();
    const el = document.getElementById("factuur_email");
    const collapse = Collapse.getOrCreateInstance(el);
    document.getElementById("factuur_email_field").value = "";
    collapse.toggle();
  }

  toggle_contract_email(event) {
    event.preventDefault();
    const el = document.getElementById("contract_email");
    const collapse = Collapse.getOrCreateInstance(el);
    document.getElementById("contract_email_field").value = "";
    collapse.toggle();
  }

  toggle_alternatief_email(event) {
    event.preventDefault();
    const el = document.getElementById("alternatief_email");
    const collapse = Collapse.getOrCreateInstance(el);
    document.getElementById("alternatief_email_field").value = "";
    collapse.toggle();
  }
}
